import FormField from 'further-ui/components/FormField';
import { Column, Row } from 'further-ui/components/Layout';
import { InvestorTaxDetails } from '../../../types';
import {
  CrsClassificationLabels,
  FatcaClassificationLabels,
} from 'further-ui/labels';
import Typography from '@mui/material/Typography';
import useDownloadFiles from 'hooks/ui/useDownloadFiles';
import ReviewButton from './ReviewButton';

type Props = {
  taxDetails: InvestorTaxDetails | null;
};

const TaxDeclarationsDetails: React.FC<Props> = ({ taxDetails }) => {
  const { downloadFiles, isPending } = useDownloadFiles();
  const hasCustomRequestAnswers = !!taxDetails?.customRequestAnswers?.length;
  const customRequestFiles =
    taxDetails?.customRequestAnswers?.flatMap(
      (answer) => answer.answerFiles ?? [],
    ) ?? [];

  const handleDownloadFiles = () => {
    downloadFiles({
      files: customRequestFiles.map((file) => ({
        url: file.previewUrl,
        name: file.name,
      })),
      fileName: 'tax-declarations-files.zip',
    });
  };

  return (
    <Column fullWidth spacing="md">
      <FormField label="FATCA classification" spacing="xxs">
        <Typography variant="body2" color="grey.600">
          {taxDetails?.fatcaClassification?.classification
            ? FatcaClassificationLabels[
                taxDetails.fatcaClassification.classification
              ]
            : '--'}
        </Typography>
      </FormField>
      <FormField label="CRS classification" spacing="xxs">
        <Typography variant="body2" color="grey.600">
          {taxDetails?.crsClassification?.classification
            ? CrsClassificationLabels[
                taxDetails.crsClassification.classification
              ]
            : '--'}
        </Typography>
      </FormField>
      <FormField label="Additional information" spacing="xxs">
        <Row centered spacing="xs">
          <Typography variant="body2" color="grey.600">
            {hasCustomRequestAnswers ? 'Completed' : '--'}
          </Typography>
          {!!customRequestFiles.length && (
            <ReviewButton
              variant="text"
              onClick={handleDownloadFiles}
              disabled={isPending}
            >
              Download file(s)
            </ReviewButton>
          )}
        </Row>
      </FormField>
    </Column>
  );
};

export default TaxDeclarationsDetails;
